import React, { Component } from 'react'
import ProfilePage from './ProfilePage'


export default class Hjem extends Component {
  render() {
    return (
      <div>
       <ProfilePage/>
       </div>
    
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Hjem.js